import { getPathString, isObjectValueType } from '@helpers'
import { BIND_TYPE, EXPAND_FIELD_PREFIX, FIELD_VALUE_TYPE } from '@constants'
import { FormRow } from '@types'

export const getExpandsParamForForm = (fields: FormRow[]) => {
  const expands = new Set<string>()

  fields.forEach(field => {
    const fieldCode = field.value || field.code
    const pathArray = field.pathArray || []

    if (!fieldCode) {
      return
    }

    if (
      pathArray?.length &&
      field.bindType === BIND_TYPE.FIELD &&
      (!field.dropDownObjectCode || field.embeddedObjectCode === field.dropDownObjectCode)
    ) {
      // Для вложенного поля раскрываем только ссылочную часть пути.
      // Последний элемент pathArray не включаем, потому что это отображаемое поле, а не ref.
      const pathsForExpand = pathArray.slice(0, -1)
      pathsForExpand.unshift({
        field: fieldCode,
        valueType: field.valueType as FIELD_VALUE_TYPE,
        objectCode: field.objectCode || '',
        refValueType: field.valueType as FIELD_VALUE_TYPE,
      })

      expands.add(
        `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
      )
    }
    if (isObjectValueType(field.valueType)) {
      expands.add(`${fieldCode}:${EXPAND_FIELD_PREFIX}${fieldCode}`)
    }
  })

  return [...expands]
}
